import axios from 'axios';
import useAuthStore from '../store/authStore';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:4000/api',
  withCredentials: true,
});

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 401) {
      useAuthStore.getState().clearUser();
    }
    return Promise.reject(error);
  }
);

// Search content across all types (audios, ebooks, series)
export const searchContent = async (query, options = {}) => {
  const {
    page = 1,
    limit = 20,
    contentType = '',
    language = '',
    categoryId = ''
  } = options;

  const params = new URLSearchParams({
    query,
    page,
    limit
  });

  if (contentType) params.append('content_type', contentType);
  if (language) params.append('language', language);
  if (categoryId) params.append('category_id', categoryId);

  const response = await api.get(`/search?${params.toString()}`);
  return response.data;
};

// Get search suggestions as user types
export const getSearchSuggestions = async (query, limit = 10) => {
  const params = new URLSearchParams({
    query,
    limit
  });

  const response = await api.get(`/search/suggestions?${params.toString()}`);
  return response.data;
};

// Get trending search terms
export const getTrendingSearches = async () => {
  const response = await api.get('/search/trending');
  return response.data;
};